import { FaExclamationCircle } from "react-icons/fa";
import { GenericBankFeedsButton } from "./GenericBankFeedsButton";

export const ErrorComponent = ({ errorMessage }: { errorMessage: string }) => {
  return (
    <>
      <div className="pt-4 pr-12 pl-12">
        <div
          className="flex items-center justify-center"
          style={{
            textAlign: "center",
            verticalAlign: "middle",
          }}>
          <FaExclamationCircle
            size={50}
            style={{
              textAlign: "center",
            }}></FaExclamationCircle>
        </div>
        <div className="text-lg font-bold pb-2" style={{ textAlign: "center" }}>
          Something went wrong
        </div>
        <div className="text-sm" style={{ textAlign: "center" }}>
          {errorMessage}
        </div>
      </div>
      <div
        style={{
          minHeight: 275,
        }}></div>

      <GenericBankFeedsButton
        text="Close"
        onClick={() => {
          window.close();
        }}
        disabled={false}
      />
    </>
  );
};
